<template>
  <CFullScreenLoader v-if="isLoadingContent" fit-parent />
  <FoldersFilesGrid v-else-if="!launchDarkly.show_content_selector_list_view" />
  <FoldersFilesList v-else-if="launchDarkly.show_content_selector_list_view" />
  <div v-else class="h-full w-full flex items-center justify-center" :style="{ color: themeVars.primary3 }">
    <div class="flex flex-col gap-3 items-center justify-center max-w-[400px] text-center">
      <CIcon icon="folder-open" size="36px" />
      <div class="font-size-[20px]">
        {{ t('canvasUI.contentSelectorApp.allContent.emptyFolder') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type ComputedRef } from 'vue'
import { inject, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import CFullScreenLoader from '@lib/components/CFullScreenLoader/CFullScreenLoader.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { useStore, useStoreApi } from '@content-selector/composables/useStore'
import { usePopularity, EntityType } from '@canvas-builder/composables/usePopularity'
import FoldersFilesGrid from '@content-selector/components/Content/AllContent/Grid/FoldersFilesGrid.vue'
import FoldersFilesList from '@content-selector/components/Content/AllContent/List/FoldersFilesList.vue'
import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'

const themeVars = useThemeVars()
const { t } = useI18n()
const { activeFolder, setState } = useStore()
const { fetchPopularityData } = usePopularity()
const { state: api } = useStoreApi()
const isLoadingContent = ref(false)

const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
  'launchDarkly',
  computed(() => ({})),
)

onMounted(async () => {
  if (launchDarkly.value.show_popularity_icons) {
    fetchPopularityData(EntityType.FILE)
  }

  isLoadingContent.value = true
  setState({ activeFolder: await api.folderItemsFetcher?.(activeFolder.value?.id), activeFile: null })
  isLoadingContent.value = false
})
</script>
